<template>
  <div>
    <div class="header-search">
      <input 
        @keydown.enter="search()"
        v-model="input_str"
        :placeholder="lg('',{
          en: 'Search by owner or collectible',
          zh: '搜索收藏品/拥有者',
        })"
      />
      <i @click="search()" class="input-icon-search fa fa-search"></i>

      <i 
        v-if="is_mobile || input_str" 
        @click="padClose()" 
        class="input-icon-close fa fa-times"
      ></i>
    </div>

    <div v-if="status_block_search_res_show" class="block-search-res" @click="padClicked()">
      <div class="boxed py-4">
        <div v-if="status_ajaxing_list" class="text-dark tac p-5">
          Searching...
        </div>

        <div v-else-if="status_searched && list_on_show.length === 0" class="text-dark tac p-5">
          No Result
        </div>

        <div v-else class="list-main-prod">
          <div class="item mb-4" v-for="(item,index) of list_on_show" :key="index">
            <CpCardProd 
              @click.native="padClose()" 
              :data="item" 
              @showPopupShareItem="showPopupShareItem"
            />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'searchBar',
  components: {},
  props: [],
  data() {
    return {
      
      input_str: '',
      is_mobile: (function(){
        if(document.body.clientWidth <= 788){
          return true
        }else{
          return false
        }
      })(),

      status_searched: false,

      status_ajaxing_list: false,
      list_on_show: [],

    }
  },
  computed: {
    status_block_search_res_show(){
      let v = this
      if(v.input_str && (v.list_on_show.length || this.status_searched)){
        return true
      }else{
        return false
      }
    },
  },
  watch: {
    input_str(val){
      let v = this
      if(!val && !v.is_mobile){
        v.padClose()
      }
      if(!val && v.is_mobile){
        v.padClean()
      }
    },
    status_block_search_res_show(val){
      if(val){
        document.querySelector('body').classList.add('lock-scroll')
      }
      else{
        document.querySelector('body').classList.remove('lock-scroll')
      }
    },
  },
  methods: {

    padClean(){
      this.status_searched = false
      this.list_on_show = []
    },
    padClose(){
      this.input_str = ''
      this.status_searched = false
      this.list_on_show = []
      document.querySelector('body').classList.remove('lock-scroll')
      this.$emit('closeSearchPad')
    },
    padClicked(){
      let v = this
      if(v.status_searched){
        v.status_searched = false
      }
    },
    async search(){
      let v = this

      if(!v.input_str){
        return
      }

      let res = await v.api('list_asset_search',{
        keyword: v.input_str,
      },{
        vue: v,
        key_ajaxing: 'status_ajaxing_list',
        key_data: 'list_on_show',
      })
      v.status_searched = true
    },
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/vars.scss";

.header-search{
  position: relative;
  
  input{
    border-radius: 5px;
    height:30px;
    padding-left: 40px;
    padding-right: 40px;
    border: none;
    background-color: #eee;
    width: 100%;

    &::-webkit-input-placeholder{
      color: #666;
    }
  }

  .input-icon-search{
    position: absolute;
    left: 10px;
    top: 50%;
    display: block;
    height: 20px;
    width: 20px;
    text-align: center;;
    margin-top: -8px;
    cursor: pointer;
    color: #222;
    border-right: 1px solid #ddd;
    padding-right: 8px;
  }
  .input-icon-close{
    position: absolute;
    right: 10px;
    top: 50%;
    display: block;
    height: 20px;
    width: 20px;
    text-align: center;;
    margin-top: -8px;
    cursor: pointer;
    color: #222;
  }
}

.block-search-res{
  position: relative;
  z-index: 1;
  position: fixed;
  top: $h_header;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--bg-color);

  overflow: auto;
}
</style>